export const checkboxSx = {
  '& > input:disabled + div': {
    bgcolor: '#f5f5f5',
    borderColor: '#d6d6d6',
    color: '#d6d6d6',
  },
  '& > input:focus + div': {
    boxShadow: '0 0 0 2px #ce093740',
  },
  '&:hover': {
    bgcolor: 'transparent',
  },
  '&:hover > div': {
    borderColor: '#c2c2c2',
  },
  '&.Mui-checked:hover > div, &.MuiCheckbox-indeterminate:hover > div': {
    borderColor: '#4563b3',
  },
};
